<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path fill-rule="evenodd" d="M16.5 10A1.5 1.5 0 0118 8.5h20a1.5 1.5 0 011.5 1.5v20a1.5 1.5 0 01-3 0V13.621l-25.44 25.44a1.5 1.5 0 11-2.12-2.122L34.378 11.5H18a1.5 1.5 0 01-1.5-1.5z"/></svg>